export default __webpack_public_path__ + "static/media/okta_button_logo.b506e9c6.png";